import Animations from "./Animations";

const Main4 = () => {
    return ( 
        <div className="container justify-content-start">
          <div className="row">
            <div className="col">
              <h1>Animations</h1>
              <Animations/>
            </div>
          </div>
        </div>
     );
}
 
export default Main4;